import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Inline CTA inside assistant answer card at preview / quota hard-block (Phase 6C).
 * @param {{ variant?: 'preview' | 'hard' }} props
 */
export default function InlinePaywallPreviewCard({ variant = 'preview' }) {
  const navigate = useNavigate();
  const isHard = variant === 'hard';
  return (
    <div className="inline-paywall-preview-lock" dir="rtl">
      <div className="inline-paywall-preview-title">
        {isHard ? 'تعذّر إكمال الطلب' : 'هذه الإجابة مقطوعة للمعاينة'}
      </div>
      <p className="inline-paywall-preview-text">
        {isHard
          ? 'بلغت حد الاستخدام المسموح. سجّل الدخول أو رقّ خطتك، أو اطلع على الأسعار.'
          : 'سجل الدخول أو أنشئ حسابًا للوصول إلى الإجابة كاملة'}
      </p>
      <div className="inline-paywall-preview-actions">
        <button type="button" className="inline-paywall-btn" onClick={() => navigate('/login')}>
          تسجيل الدخول
        </button>
        <button type="button" className="inline-paywall-btn" onClick={() => navigate('/register')}>
          إنشاء حساب
        </button>
        <button type="button" className="inline-paywall-btn secondary" onClick={() => navigate('/pricing')}>
          الاطلاع على الأسعار
        </button>
      </div>
    </div>
  );
}
